export const RECEIVED_PRIVACY_SETTINGS = 'RECEIVED_PRIVACY_SETTINGS';
export const UPDATED_PRIVACY_SETTINGS = 'UPDATED_PRIVACY_SETTINGS';
